__turbopack_context__.v({
  "arrow": "style-module-scss-module__0nK6Iq__arrow",
  "component": "style-module-scss-module__0nK6Iq__component",
  "content": "style-module-scss-module__0nK6Iq__content",
  "header": "style-module-scss-module__0nK6Iq__header",
  "label": "style-module-scss-module__0nK6Iq__label",
  "number": "style-module-scss-module__0nK6Iq__number",
  "text-divider": "style-module-scss-module__0nK6Iq__text-divider",
  "titleContainer": "style-module-scss-module__0nK6Iq__titleContainer",
});
